import './styles/Header.css';

export default function OnBoardingButton({ selectedTheme, state }) {
  
  return (        
    <>
      <div className="onboarding__welcome-block">
        <h2 className={`onboarding-theme__h2 ${!selectedTheme ? "not-theme" : ""}`}>
          Welcome {state.user_session.user_name}!
        </h2>
        <div className={`onboarding-theme__username ${!selectedTheme ? "not-theme" : ""}`}>
          <p className="onboarding-theme__user_message">
            Select a color theme to begin your journey
          </p>
        </div>
      </div>
    </>);
}